import coreAPIInstance from "./coreApiInstance";

export const coreContentTagsAPIs = {
  saveCoreContentTags: ({ payload, headers }) =>
    coreAPIInstance.post(`/api/v1/content-tags/save`, payload, { headers }),
  getCoreContentTags: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/content-tags/get`, payload, { headers }),
};
